import React from "react";
import one from './pics/one.jpeg';
import two from './pics/two.jpeg';
import three from './pics/three.jpeg';
import four from './pics/four.jpeg';
import five from './pics/five.jpeg';
import six from './pics/six.jpeg';
import seven from './pics/seven.jpeg';
import eight from './pics/eight.jpeg';
import nine from './pics/nine.jpeg';
import ten from './pics/ten.jpeg';
import eleven from './pics/eleven.jpeg';
import twelve from './pics/twelve.jpeg';
import thirteen from './pics/thirteen.jpeg';
import fourteen from './pics/fourteen.jpeg';
import fifteen from './pics/fifteen.jpeg';
import sixteen from './pics/sixteen.jpeg';
import seventeen from './pics/seventeen.jpeg';
import eighteen from './pics/eighteen.jpeg';
// import nineteen from './pics/nineteen.jpeg';
import './CurrentBankAcc.css';

class CurrentBankAcc extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">
                                    فتح حساب جارى
                                    <br/>
                                    فى المانيا و
                                    <br/>
                                    تفعيل الحساب المغلق
                                </legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <div class="row">
                                        <div class="column">
                                            <img alt='' width='300px' height='200px' src={one} />
                                            <img alt='' width='300px' height='200px' src={two} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px' src={three} />
                                            <img alt='' width='300px' height='200px'src={four} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={five} />
                                            <img alt='' width='500px' height='200px'src={six} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={seven} />
                                            <img alt='' width='300px' height='200px'src={eight} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={nine} />
                                            <img alt='' width='300px' height='200px'src={ten} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={eleven} />
                                            <img alt='' width='300px' height='200px'src={twelve} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={thirteen} />
                                            <img alt='' width='300px' height='200px'src={fourteen} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={fifteen} />
                                            <img alt='' width='300px' height='200px'src={sixteen} />
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={seventeen} />
                                            {/* <img alt='' width='300px' height='200px'src={eighteen} /> */}
                                        </div>
                                        <div class="column">
                                            <img alt='' width='300px' height='200px'src={eighteen} />
                                        </div>
                                    </div>

                                    <hr/>
                                    <h3>
                                        البوست النهاردة هتكلم فيه عن فتح حساب جارى فى المانيا .. و دة يهم اى حد هيسافر و معاه حساب مغلق فى
                                        <br/>
                                        فنتيبا او اكس باتريو
                                        <br/>
                                        لان البنكين دول بيطلبوا ان يبقا معاك حساب جارى فى المانيا لتفعيل الحساب المغلق عند وصولك ل المانيا
                                        <br/>
                                        فيعتبر من احسن بنك حاليا الواحد يفتح فيه حساب جارى هو بنك
                                        <br/>
                                        N26
                                        <br/>
                                        و دة البنك اللى انا اتعاملت معاه من لحظة وصولى ل المانيا
                                        <br/>
                                        البنك ده اون لاين مقرة الاساسي في برلين بس يعنى مالوش فروع زى اى بنك تانى
                                        <br/>
                                        .............
                                        <br/>
                                        ايه هى مميزات البنك ؟
                                        <br/>
                                        1- مبيحتجش انملدونج ولا عقد سكن اثناء فتح الحساب
                                        <br/>
                                        2- من غير أى رسوم شهرية ولا حتي سنوية
                                        <br/>
                                        3- الماستر كارد العادية للبنك تقدر تطلبها من غير اى مصاريف
                                        <br/>
                                        الماستر كارد تقدر تشتري بيها عن طريق الانترنت و من غير رسوم
                                        <br/>
                                        تقدر تشري من اي سوبر ماركت او اى مكان بيقبل الماستر كارد
                                        <br/>
                                        الماستر كارد تدعم خدمة NFC
                                        <br/>
                                        الماستر كارد تقدر تسحب بيها كاش من اى ماكينة سحب فلوس من اى بنك موجود فى المانيا
                                        <br/>
                                        - لو الكارت ضاع منك فتقدر من خلال ابلكيشن البنك تقفل الكارت و تطلب كارت جديد بس هيكلفك
                                        <br/>
                                        6 يورو مصاريف الكارت الجديد
                                        <br/>
                                        .............
                                        <br/>
                                        طب ايه عيوب البنك ؟
                                        <br/>
                                        العيب الاول و انا لحد وقتنا هذا متعرضتش ليها
                                        <br/>
                                        ألا و هى ان كارت
                                        <br/>
                                        atm
                                        <br/>
                                        ليك خمس مرات تسحب بيه كاش خلال الشهر من غير فلوس و لو احتجت تسحب اكتر ف بتدفع فلوس ع السحبة
                                        <br/>
                                        ثانى عيب ان لو معاك فلوس كاش و عايز تعملها ايداع فالبنك فليك فالشهر حد اقصى 100 يورو .. و فيه اكتر من مكان تقدر تعمل فيه ايداع و بتعرف دة من خلال ابلكيشن البنك " و لو معاك اكتر فممكن تعمل ايداع فى حساب صديقك و هو يحولهم ليك و انا عملت كدة اكتر من مرة "
                                        <br/>
                                        .............
                                        <br/>
                                        طريقة التحويل من على حسابك ؟
                                        <br/>
                                        عن طريق ابلكيشن البنك تقدر بكل سهولة تحول فلوس لاي حد. كل الي عليك تكتب ال
                                        IBAN
                                        <br/>
                                        للشخص اللى عايز تحوله و تكتب المبلغ المراد تحويله
                                        <br/>
                                        .............
                                        <br/>
                                        طريقة التواصل مع البنك ؟
                                        <br/>
                                        خدمة العملاء عندهم كويسة و تقدر تتواصل معاهم من خلال الابلكيشن و تقدر تكلمهم اونلاين من خلال التطبيق او تبعتلهم ميل و بيردوا بسرعة
                                        <br/>
                                        وبردوا البنك موجود فيه نظام الدعوات ان لو دعيت حد من خلال الكود الخاص بيك لاي حد و سجل عن طريقك بتاخد انت من 10- 30 يورو ليك و لزميلك و بيتحولوا بعد ما هو يفتح الاكونت بتاعه و يفعله و يبدأ يصرف من الحساب
                                        <br/>
                                        حاليا اللى هيفتح من <a target='_blank' rel='noreferrer' href='https://app.n26.com/referral/ca19359@n26'>اللينك</a> دة هياخد 10 يورو
                                        <br/>
                                        ممكن البنك يزود المبلغ شوية او يقلله فى اى وقت .. لان العرض مش ثابت
                                        <br/>
                                        .....................................................
                                        <br/>
                                        طريقة فتح الحساب ؟
                                        <br/>
                                        فتح الحساب مش هياخد وقت
                                        و هحكى تجربتى
                                        <br/>
                                        اولا لازم يبقا معاك خط و رقم تليفون المانى
                                        <br/>
                                        لما توصل المانيا فهيبقا فيه اكتر من شركة تقدر تشترى منها
                                        مثلا
                                        <br/>
                                        ALDI / Vodafone / O2
                                        <br/>
                                        يعتبر دول الاشهر
                                        <br/>
                                        انا شخصيا اشتريت من ألدى لانه ارخص
                                        <br/>
                                        و دة بتروح لاى ماركت ألدى قريب منك و بتشترى الخط و تقريبا من 10 ل 13 يورو و بيبقا فيه رصيد
                                        <br/>
                                        10 يورو
                                        <br/>
                                        و ممكن تسأل الكاشير ع التفعيل و لو وافقت تفعله فلازم يكون معاك الباسبور و بعدها فى خلال ساعتين هيتفعل
                                        <br/>
                                        او تنزل الابلكيشن الخاص ب
                                        <br/>
                                        Aldi Talk
                                        <br/>
                                        و بتعمل اكونت خاص بيك و تملى البيانات و هتعمل مكالمة فيديو كول مع الموظف و هيتأكد من البيانات فقط لا غير و بعدها بساعتين تلاتة الخط هيتفعل
                                        <br/>
                                        - نقطة مهمة ان اوقات الخط ميتفعلش بعد مرور ساعات فلازم تفصل الموبايل و تشغله تانى و متشغلش الداتا قبل ما تفعل الباقة و الباقة بتعملها من خلال الابلكيشن او انك تتصل بيهم و ممكن يبقا فيه عرض لاول شهر و من تانى شهر ترجع للباقة الاساسية .. 2 جيجا و حوالى 300--400 مكالمات و رسائل لاى خط فى اوروبا مش متذكر كام بالظبط .. والباقة دى تقريبا ب 8 يورو
                                        <br/>
                                        - تعديل -
                                        <br/>
                                        فيه شركة اسمها
                                        <br/>
                                        premiumsim
                                        <br/>
                                        انا مشترك فيها حاليا و يعتبر افضل من الشركة اللى فوق و عروضها افضل
                                        <br/>
                                        بدفع فالشهر 10 يورو و الباقة
                                        <br/>
                                        4 جيجا نت
                                        <br/>
                                        مكالمات و رسائل غير محدودة لاى رقم داخل اوروبا
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.premiumsim.de?kw=5f40e23ac4d64f980b1b11c31fd021e6'>premiumsim.de</a>
                                        <br/>
                                        بس عيبه ان لازم حساب بنكى و انت بتفتح الحساب و ممكن تكتب عادى ايبان بنك ستور بنك " فنتيبا " بس الكارت بيوصل ليك فى خلال يومين تلاتة عمل بالبريد ..
                                        <br/>
                                        ..................
                                        <br/>
                                        ثانيا هتفتح من <a target='_blank' rel='noreferrer' href='https://app.n26.com/referral/ca19359@n26'>اللينك</a> دة
                                        <br/>
                                        وتمشى على الخطوات بالترتيب زى ما هو موجود فالصور
                                        <br/>
                                        بس فيه كذة نقطة لازم الواحد ياخد باله منها
                                        <br/>
                                        - صورة رقم 6
                                        <br/>
                                        لو انت ساكن عند صحبك ف اكتب ف
                                        <br/>
                                        c/o
                                        <br/>
                                        وبعد كدة اسم صحبك المكتوب على صندوق البريد لان الكارت هيجى على عنوانه
                                        <br/>
                                        "ممكن تغير العنوان بعد كدة عادى"
                                        <br/>
                                        - صورة رقم 10
                                        <br/>
                                        اتأكد ان الكود هيبقا مكتوب " ممكن الكود يتغير لان كل فترة الكود بيتغير بس اللينك بيبقا ثابت " لازم تتأكد عشان الفلوس تجيلك و تجيلى
                                        <br/>
                                        بعد ما هتمشى على الخطوات زى ما قى الصور فيبعتوا ليك فى الاخر لينك الابلكيشن على موبايلك و هتنزله على موبابلك و بعد كدة تدخل تكتب الايميل بتاعك و تكمل البياانات المطلوبة و هتعمل فيديو كول بالانجليزى او الالمانى و مش هياخد معاك اكتر من ربع ساعة و بيبقا للتأكد من المعلومات مش اكتر و تانى يوم الحساب هيتفعل و الكارت هيجيلك فى خلال اسبوع و تفتح الابلكيشن و تفعل الكارت و يبقا كدة انت خلاص خلصت كل حاجة
                                        <br/>
                                        و هتلاقى فالحساب بتاعك ال 10 يورو
                                        <br/>
                                        زى ما هو موجود فالصورة كدة
                                        <br/>
                                        "فيه جديد . ان لازم تفعل الكارت الاول و تصرف بيه ب 15-25 يورو عشان ال
                                        <br/>
                                        الهدية يورو تجيلك"
                                        <br/>
                                        "لما الاكونت بتاعك يتفعل و يبعتولك تفاصيل الحساب ف هتاخد الايبان و تكتبه على موقع فنتيبا
                                        <br/>
                                        وبس كدة
                                        <br/>
                                        "ممكن التفاصيل فالصور اللى تحت تتغير مثلا او يزودوا حاجة بس هتبقا هى هى او مثلا شكل الصفحة يتغير
                                        <br/>
                                        لان اكيد كل فترة بيغيروا الاستايل كدة بس هى هى نفس الكلام مفيش تغير "
                                        <br/>
                                        ...........
                                        <br/>
                                        <a href='/closedbankaccount_financialguarantor/fintiba_sutorbank'>طريقة فتح الحساب البنكى المغلق فى فانتيبا (ستور بنك)</a> و تفعيله عند الوصول لالمانيا
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default CurrentBankAcc;
